/* =====================================================================
   LATAKAN - wishlist.js : page Favoris (store partage window.LatakanWish)
   Cle latakan_wishlist_v1. Snapshots produit "favSnap" crees au clic coeur
   dans catalogue-engine.js. Forme reelle d'un favori :
     { id:'team|imgk|season|type|player', team, imgk, season, type,
       title, price (Number), img, badge, stock ('in'|'low'|'out'),
       lowN, size, addedAt }
   -> imgk == handle Shopify (cf. snippets/catalog-product-json.liquid).

   Cette page :
   - affiche chaque favori avec son image (repli fetch /products/<handle>.js),
   - retire les favoris dont le produit n'existe plus (404),
   - "Voir" / vignette ouvrent la VUE RAPIDE via /collections/all?qv=<handle>,
   - gere selection, tri, filtres, suppression et ajout panier.
   Le store partage tient a jour le coeur du header et l'onglet (subscribe).
   ===================================================================== */
(function () {
  'use strict';

  var Wish = window.LatakanWish;
  if (!Wish) return; // socle core-engine.js absent : rien a faire

  /* ----------------------------- utils ------------------------------ */
  function escA(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function priceNum(v) { var n = parseFloat(String(v == null ? '' : v).replace(/[^\d.,]/g, '').replace(',', '.')); return isFinite(n) ? n : 0; }
  function eur(n) { return (Number(n) || 0).toFixed(2).replace('.', ',') + ' €'; }

  // imgk == handle Shopify. Repli sur l'id (team|imgk|...) si absent.
  function handleOf(x) { return x && (x.imgk || (x.id ? String(x.id).split('|')[1] : '')) || ''; }
  // Cible vue rapide : /collections/all?qv=<handle> (catalogue-engine ouvre la QV).
  function qvUrl(x) { var h = handleOf(x); return '/collections/all?qv=' + encodeURIComponent(h); }
  // Normalise une URL d'image issue d'un fetch produit (.js) : //cdn -> https, &width=600.
  function normImg(src) {
    if (!src) return '';
    var u = String(src);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (u.indexOf('width=') === -1) u += (u.indexOf('?') >= 0 ? '&' : '?') + 'width=600';
    return u;
  }

  var STOCK = { in: { cls: 'in', lbl: 'En stock' }, low: { cls: 'low', lbl: 'Stock faible' }, out: { cls: 'out', lbl: 'Épuisé' } };
  function stockOf(x) { return STOCK[x && x.stock] || STOCK.in; }
  var BADGE = { new: 'Nouveau', best: 'Top vente', retro: 'Rétro', ltd: 'Édition limitée' };

  /* ------------------------- etat toolbar --------------------------- */
  var SORT = 'recent';     // recent | price-asc | price-desc | name | stock
  var FILT = 'all';        // all | in
  var selected = {};       // { id: 1 }
  var enriching = false;   // garde anti-reentrance pour la passe images/existence

  /* --------------------------- rendu carte -------------------------- */
  function wlcHTML(x) {
    var id = escA(x.id);
    var href = escA(qvUrl(x));
    var st = stockOf(x);
    var sel = !!selected[x.id];
    var img = x.img
      ? '<img class="wlc__img" src="' + escA(x.img) + '" alt="' + escA(x.title) + '" loading="lazy" decoding="async">'
      : '';
    var badge = (x.badge && BADGE[x.badge])
      ? '<span class="wlc__badge wlc__badge--' + escA(x.badge) + '">' + BADGE[x.badge] + '</span>'
      : '';
    var stockTxt = st.cls === 'low' && x.lowN ? ('Plus que ' + x.lowN) : st.lbl;
    return '<article class="wlc' + (sel ? ' is-selected' : '') + '" data-id="' + id + '">' +
      '<div class="wlc__media' + (x.img ? '' : ' wlc__media--ph') + '" data-wl-open="' + href + '" role="link" tabindex="0" aria-label="Voir ' + escA(x.title) + '">' +
        '<label class="wlc__check"><input type="checkbox" class="wlc__cb" data-wl-cb="' + id + '"' + (sel ? ' checked' : '') + ' aria-label="Sélectionner ce maillot"><span></span></label>' +
        '<button class="wlc__fav is-on" type="button" data-wl-remove="' + id + '" aria-label="Retirer des favoris" aria-pressed="true"><svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-9.3-9A4.6 4.6 0 0 1 12 6a4.6 4.6 0 0 1 9.3 5C19 15.4 12 20 12 20Z"/></svg></button>' +
        badge + img +
        '<span class="wlc__size">Voir</span>' +
      '</div>' +
      '<div class="wlc__body">' +
        '<h3 class="wlc__title"><a href="' + href + '" data-wl-open="' + href + '">' + escA(x.title) + '</a></h3>' +
        '<div class="wlc__foot">' +
          '<span class="wlc__price">' + eur(x.price) + '</span>' +
          '<span class="wlc__stock wlc__stock--' + st.cls + '"><i></i>' + escA(stockTxt) + '</span>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  /* --------------------------- liste triee -------------------------- */
  function visibleList() {
    var list = Wish.items().slice();
    if (FILT === 'in') list = list.filter(function (x) { return x.stock !== 'out'; });
    if (SORT === 'price-asc') list.sort(function (a, b) { return priceNum(a.price) - priceNum(b.price); });
    else if (SORT === 'price-desc') list.sort(function (a, b) { return priceNum(b.price) - priceNum(a.price); });
    else if (SORT === 'name') list.sort(function (a, b) { return String(a.title).localeCompare(String(b.title), 'fr'); });
    else if (SORT === 'stock') { var rank = { in: 0, low: 1, out: 2 }; list.sort(function (a, b) { return (rank[a.stock] || 0) - (rank[b.stock] || 0); }); }
    else list.sort(function (a, b) { return (b.addedAt || 0) - (a.addedAt || 0); });
    return list;
  }

  /* --------------------------- compteurs ---------------------------- */
  function set(sel, v) { var e = document.querySelector(sel); if (e) e.textContent = v; }
  function updateSummary() {
    var all = Wish.items();
    var n = all.length;
    var inStock = all.filter(function (x) { return x.stock !== 'out'; }).length;
    var val = all.reduce(function (s, x) { return s + priceNum(x.price); }, 0);
    set('#wlPill', n + ' article' + (n > 1 ? 's' : ''));
    set('#wlSubCount', n);
    set('#wlInstock', inStock);
    set('#wlValue', eur(val));
    set('#wlSelectLbl', 'Tout sélectionner (' + n + ')');
    var addAll = document.querySelector('#wlAddAll'); if (addAll) addAll.disabled = inStock === 0;
  }
  function updateToolbar() {
    var ids = visibleList().map(function (x) { return x.id; });
    var selCount = ids.filter(function (id) { return selected[id]; }).length;
    var all = document.querySelector('#wlSelectAll');
    if (all) { all.checked = ids.length > 0 && selCount === ids.length; all.indeterminate = selCount > 0 && selCount < ids.length; }
    var del = document.querySelector('#wlDeleteSel'); if (del) del.disabled = selCount === 0;
  }

  /* ----------------------------- rendu ------------------------------ */
  function renderPage() {
    // purge des selections devenues obsoletes
    var present = {}; Wish.items().forEach(function (x) { present[x.id] = 1; });
    Object.keys(selected).forEach(function (id) { if (!present[id]) delete selected[id]; });

    updateSummary();
    var host = document.querySelector('[data-wishlist-grid]'); if (!host) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = visibleList();
    if (!list.length) {
      host.innerHTML = ''; host.hidden = true;
      if (empty) empty.hidden = false;
      updateToolbar();
      return;
    }
    if (empty) empty.hidden = true;
    host.hidden = false;
    host.innerHTML = list.map(wlcHTML).join('');
    updateToolbar();
  }

  /* ------------- enrichissement : images + produits disparus -------- */
  // Pour chaque favori : verifie l'existence via /products/<handle>.js.
  //  - reponse non-ok / 404 -> produit disparu -> retire du store, pas d'affichage.
  //  - image manquante/cassee -> recupere featured_image / images[0], re-stocke.
  function enrichAll() {
    if (enriching) return;
    var items = Wish.items();
    if (!items.length) return;
    enriching = true;

    var pending = items.map(function (x) {
      var handle = handleOf(x);
      if (!handle) return Promise.resolve();
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          if (!r.ok) return null; // erreur reseau passagere : on ne retire pas
          return r.json().then(function (d) { return { data: d }; }).catch(function () { return null; });
        })
        .then(function (res) {
          if (!res) return;
          if (res.gone) { Wish.remove(x.id); return; }
          var d = res.data || {};
          // image : on ne (re)stocke que si l'actuelle est vide/cassee
          if (!x.img) {
            var src = d.featured_image || (d.images && d.images[0]) || '';
            var norm = normImg(src);
            if (norm) {
              x.img = norm;
              try { Wish.save && Wish.save(); } catch (e) {}
            }
          }
        })
        .catch(function () { /* reseau : on garde le favori tel quel */ });
    });

    Promise.all(pending).then(function () {
      enriching = false;
      persistSnapshots(); // sauvegarde les img recuperees
      renderPage();
    });
  }

  // Re-ecrit le store apres mutation des snapshots (img recuperee) sans changer l'ordre.
  function persistSnapshots() {
    try {
      var KEY = 'latakan_wishlist_v1';
      localStorage.setItem(KEY, JSON.stringify(Wish.items()));
    } catch (e) {}
  }

  /* ----------------- ajout panier des disponibles ------------------- */
  function addAllAvailable(btn) {
    var Cart = window.LatakanCart, Core = window.LatakanCore;
    if (!Cart) { window.location.href = '/cart'; return; }
    var list = Wish.items().filter(function (x) { return x.stock !== 'out'; });
    if (!list.length) return;
    if (btn) btn.disabled = true;

    var tasks = list.map(function (x) {
      var handle = handleOf(x);
      if (!handle) return Promise.resolve(false);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return false;
          var v = (d.variants || []).filter(function (vr) { return vr.available; })[0] || (d.variants || [])[0];
          if (!v) return false;
          var src = normImg(d.featured_image || (d.images && d.images[0]) || x.img || '');
          Cart.add({ id: d.id, variantId: v.id, title: x.title || d.title, img: src, price: priceNum(x.price) || (d.price / 100), size: (x.size || (v.title && v.title !== 'Default Title' ? v.title : 'Unique')) });
          return true;
        })
        .catch(function () { return false; });
    });

    Promise.all(tasks).then(function (res) {
      if (btn) btn.disabled = false;
      if (res.some(Boolean) && Core && Core.openCart) Core.openCart();
      else if (!res.some(Boolean)) window.location.href = '/cart';
    });
  }

  /* --------------------------- navigation --------------------------- */
  function openQv(url) { if (url) window.location.href = url; }

  /* --------------------------- interactions ------------------------- */
  document.addEventListener('click', function (e) {
    // retirer un favori (coeur rempli)
    var rm = e.target.closest('[data-wl-remove]');
    if (rm) { e.preventDefault(); var id = rm.getAttribute('data-wl-remove'); delete selected[id]; Wish.remove(id); return; }

    // ouvrir la vue rapide (vignette ou titre)
    var open = e.target.closest('[data-wl-open]');
    if (open) { e.preventDefault(); openQv(open.getAttribute('data-wl-open')); return; }

    // supprimer la selection
    if (e.target.closest('#wlDeleteSel')) {
      Object.keys(selected).forEach(function (id) { if (selected[id]) Wish.remove(id); });
      selected = {};
      return;
    }

    // ajouter tous les disponibles au panier
    var addAll = e.target.closest('#wlAddAll');
    if (addAll) { e.preventDefault(); addAllAvailable(addAll); return; }

    // panneau filtres
    var ftog = e.target.closest('#wlFilters');
    if (ftog) { var p = document.querySelector('#wlFiltPanel'); if (p) { var willOpen = p.hidden; p.hidden = !willOpen; ftog.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); } return; }
    var fopt = e.target.closest('[data-filt]');
    if (fopt) { FILT = fopt.getAttribute('data-filt') || 'all'; var pan = document.querySelector('#wlFiltPanel'); if (pan) pan.hidden = true; var ft = document.querySelector('#wlFilters'); if (ft) ft.setAttribute('aria-expanded', 'false'); renderPage(); return; }
  });

  // clavier : ouvrir la vue rapide depuis une vignette focalisable
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var open = e.target.closest && e.target.closest('.wlc__media[data-wl-open]');
    if (open) { e.preventDefault(); openQv(open.getAttribute('data-wl-open')); }
  });

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-wl-cb]');
    if (cb) {
      var id = cb.getAttribute('data-wl-cb');
      if (cb.checked) selected[id] = 1; else delete selected[id];
      var art = cb.closest('.wlc'); if (art) art.classList.toggle('is-selected', cb.checked);
      updateToolbar();
      return;
    }
    var all = e.target.closest('#wlSelectAll');
    if (all) {
      if (all.checked) visibleList().forEach(function (x) { selected[x.id] = 1; });
      else selected = {};
      renderPage();
      return;
    }
    var sort = e.target.closest('#wlSort');
    if (sort) { SORT = sort.value; renderPage(); return; }
  });

  /* --------------------------- cycle de vie ------------------------- */
  // Re-render quand le store change (retrait, toggle depuis une autre page/onglet).
  Wish.subscribe(renderPage);
  window.addEventListener('storage', function (e) { if (e.key === 'latakan_wishlist_v1') renderPage(); });

  function boot() {
    renderPage();   // 1er rendu immediat depuis le store (img deja en snapshot)
    enrichAll();    // 2e passe : images manquantes + purge des produits disparus
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  window.LatakanWishlistPage = { render: renderPage, refresh: enrichAll };
})();
